import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from '../auth.service';
import { PayGuard } from '../pay.guard';
import { LocalService } from '../local.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  serial:number=0;
  loginForm: FormGroup;
  errorMessage: string = '';
  resetStatus:string = '';
 
constructor( private angularFS:AngularFirestore, private router:Router, private auth:AuthService
    ,private pay:PayGuard,private local:LocalService, private fb:FormBuilder) {
      this.createForm();
    }
    createForm() {
      this.loginForm = this.fb.group({
        email: [''],
        password: ['',Validators.required]
      });
    }

  loginWithGoogle(){
    this.auth.googleLogin().then(res => {
      this.router.navigate(['choose']);
    })
  }

  loginWithFacebook(){
    this.auth.facebookLogin().then(res => {
      this.router.navigate(['choose']);
    }
    )
  }

  tryLogin(value){
    this.auth.login(value)
    .then(res => {
      this.router.navigate(['choose'])
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
    })
  }

  ngOnInit(): void {
    this.pay.key = 0;

    
  }

}
